import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const config = defineConfig({
    // Здесь можно прописать любые глобальные CSS-правила
    globalCss: {
        // Убираем обводку, тень и подчёркивание у всех <a>
        'a, a:hover, a:active, a:focus-visible, button:hover, button:active, button:focus-visible, input:hover': {
            textDecoration: 'none !important',
            boxShadow: 'none !important',
            outline: 'none !important',
            outlineWidth: 'unset !important',
            outlineOffset: 'unset !important',
            outlineStyle: 'none !important',
            outlineColor: 'initial !important',
            borderColor: 'inherit !important',
        },
    },
    theme: {
        tokens: {
            colors: {
                brand: {
                    100: { value: 'rgba(3, 77, 33, 1)' },
                    200: { value: 'rgba(3, 77, 33, 1)' },
                    300: { value: 'rgba(3, 77, 33, 1)' },
                    400: { value: 'rgba(3, 77, 33, 1)' },
                    500: { value: 'rgba(3, 77, 33, 1)' },
                    600: { value: 'rgba(3, 77, 33, 1)' },
                    700: { value: 'rgba(3, 77, 33, 1)' },
                },
            },
        },
        semanticTokens: {
            colors: {
                brand: {
                    solid: { value: '{colors.brand.500}' },
                    contrast: { value: '{colors.white}' },
                    muted: { value: '{colors.brand.300}' },
                    subtle: { value: '{colors.brand.100}' },
                    emphasized: { value: '{colors.brand.600}' },
                    focusRing: { value: '{colors.brand.500}' },
                },
            },
        },
    },
});

export const system = createSystem(defaultConfig, config);
